import { FunctionComponent } from 'react';
import './features-4.scss';
import BuyNowButton from '../../shared/buy-now-button/buy-now-button';
import H2 from '../../shared/html-tags/h2';
import H1 from '../../shared/html-tags/h1';
import DIV from '../../shared/html-tags/div';

export type Props = {};

const Features4TopBanner: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <div className="page-content bg-top-features-4 top-banner" style={{ height: '25.25rem' }}>
      <div className="inner-content">
        <div
          className="top-left"
          style={{
            display: 'flex',
            justifyContent: 'stretch',
            alignItems: 'center',
            marginLeft: '-8rem',
            paddingLeft: '8rem',
            backgroundImage: 'url(/img/features/3/28-bang-300x300.png)',
            backgroundPosition: '0 17rem',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '12.5rem',
            height: '24.75rem',
          }}
        >
          <div>
            <H2 language="de">
              Datenanalyse leicht gemacht mit PS IMAGO <b style={{ color: 'crimson' }}>PRO</b>
            </H2>
            <H1 language="de" style={{ lineHeight: '1.25' }}>
              Verteilung und Verwaltung
              <br /> von SPSS Statistiken
            </H1>
            <H2 language="de" style={{ fontSize: '1.25rem', marginTop: '0.5rem' }}>
              Erziele schneller, präzisere Ergebnisse,
              <br />
              während du Zeit und Kosten sparst.
            </H2>{' '}
            <BuyNowButton order={'buy'} />
          </div>
        </div>
        <DIV language="de" className="top-right">
          <img
            src="/img/features/4/p4-478x500.png"
            alt="Roboter liest die 2x4 PS IMAGO PRO News"
            style={{ border: 'none', marginTop: '0', maxHeight: '25.25rem' }}
          />
        </DIV>
      </div>
    </div>
  );
};

export default Features4TopBanner;
